import type { ThemeType } from '@/config/objects/theme-types';
import { useOutletContext } from 'react-router-dom';

interface ThemeTypeContext {
  themeType: ThemeType | undefined;
  isLoading: boolean;
}

export function useThemeTypeContext() {
  return useOutletContext<ThemeTypeContext>();
}
